import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    blog: PropTypes.object.isRequired,
  },
  getInitialState() {
    return {
      blog: this.props.blog,
    };
  },
  onError() {
    var updated = this.state.circle;
    updated.main_image_url = "/images/ja2/img_noimage.gif";
    this.setState({
      blog: updated,
    });
  },
  render() {
    var blog = this.state.blog;
    return (
      <div className="background-white mt20 pd10">
        <a href={`/blogs/${blog.id_to_param}`}>
          <p className="bold line-1">{blog.title}</p>
          <p className="mb0 small line-1">
            {blog.publish_date_disp}&nbsp;&nbsp;{blog.circle.name}
          </p>
        </a>
      </div>
    );
  },
});
